export default class UrlBuilder {
    constructor(baseUrl) {
        this._baseUrl = baseUrl;
        this._queryParams = null;

        this.setQueryParams = function (queryParams) {
            this._queryParams = queryParams;

            return this;
        };

        this.build = function () {
            if (!this._queryParams) {
                return this._baseUrl;
            }

            return `${this._baseUrl}?${new URLSearchParams(this._queryParams).toString()}`;
        };
    }
}
